import {
  Field as IField,
  RowFieldGroup as IRowFieldGroup,
  SECTION_BREAK,
  SECTION_BREAK_SMALL,
} from "@/core/types/types";
import Field from "../../Field";
import { Card } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import RowFieldGroup from "@/core/components/Form/FormLayer/RowFieldGroup";
import rowGroupManager from "@/core/utils/rowGroupManager";

const PlainFieldGroup = ({ groupItems }: { groupItems: IField[] }) => {
  const rowGroupedItems: IRowFieldGroup[] = groupItems.reduce(
    rowGroupManager,
    []
  );

  return (
    <Card
      sx={{
        padding: 2,
        boxShadow: "none",
        "& > .MuiBox-root:empty": {
          mt: 0,
          mb: 0,
        },
        "& > .MuiBox-root:empty + .MuiBox-root:not(:empty)": {
          mt: 2,
        },

        "& > .MuiBox-root:not(:empty) ~ .MuiBox-root:not(:empty)": {
          mt: 2,
        },
        "& > .MuiBox-root:not(:empty):only-child": {
          mt: 0,
        },
      }}
    >
      {rowGroupedItems.map((fields: IRowFieldGroup) => {
        const firstFieldEntry: IField = fields[0];
        const isSectionBreak: boolean =
          !!firstFieldEntry.properties?.[SECTION_BREAK];
        const isSmallSectionBreak: boolean =
          !!firstFieldEntry.properties?.[SECTION_BREAK_SMALL];
        const isGroup: boolean = fields.length > 1;

        const content = isGroup ? (
          <RowFieldGroup groupItems={fields} />
        ) : (
          <Field field={firstFieldEntry} />
        );
        return (
          <Box
            key={firstFieldEntry.id}
            mb={isSectionBreak ? 4 : isSmallSectionBreak ? 3 : 0}
          >
            {content}
          </Box>
        );
      })}
    </Card>
  );
};

export default PlainFieldGroup;
